import { FontAwesome } from '@expo/vector-icons';
import * as React from 'react';

import { Icon } from './internal';

export const SortAmountAsc: Icon = ({ color = '#000000', size = 24 }) => (
  <FontAwesome name="sort-amount-asc" size={size} color={color} />
);
